import { useEffect } from 'react';
import { getCalApi } from '@calcom/embed-react';
import { CAL_NAMESPACE, CAL_UI_CONFIG } from '@/config/calEmbed';
import { trackMetaPixelEvent } from '@/lib/metaPixel';

/**
 * Site-wide Cal.com element-click embed initializer (mounted once in App).
 *
 * Loads Cal's embed.js and runs Cal("init", "ifa") with the namespace UI
 * config — after which any element carrying the data-cal-* trigger
 * attributes (see calTriggerProps in src/config/calEmbed.ts) opens the
 * booking calendar in Cal's own modal. The embed origin defaults to
 * https://app.cal.com inside embed-react, matching the official snippet.
 * getCalApi is idempotent, so the inline <Cal /> modals reuse the same
 * loader rather than double-injecting.
 */
export const useCalEmbed = () => {
  useEffect(() => {
    (async () => {
      try {
        const cal = await getCalApi({ namespace: CAL_NAMESPACE });
        cal('ui', { ...CAL_UI_CONFIG });
        // Meta Pixel conversion: fire the standard "Schedule" event when a
        // booking completes in any ifa embed (popups and element-click).
        // bookingSuccessfulV2 is the supported success action; no booking
        // payload is forwarded — just the event name.
        cal('on', {
          action: 'bookingSuccessfulV2',
          callback: () => trackMetaPixelEvent('Schedule'),
        });
      } catch (e) {
        console.warn('Cal embed init failed', e);
      }
    })();
  }, []);
};
